import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dashboard-main-actions" }
const _hoisted_2 = {
  key: 0,
  class: "empty-text"
}
const _hoisted_3 = {
  key: 1,
  class: "list"
}

import type { Appeal } from "@/modules/appeal/types";
import { onMounted, ref, watch } from "vue";
import { debounce } from "@/helpers/debounce";
import { getAppealsBySearch } from "@/modules/appeal/services/appeal.services";
import AppealsListItem from "@/modules/appeal/components/AppealsListItem.vue";
import BaseWidgetTemplate from "@/components/BaseWidgetTemplate.vue";
import MainHeader from "@/modules/layouts/components/headers/MainHeader.vue";
import DashboardActions from "@/modules/manager-dashboard/components/DashboardActions.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppealsPage',
  setup(__props) {

const searchString = ref("");
const appeals = ref<Appeal[]>([]);

const debouncedSearch = debounce(async () => await fetch(), 500);

const fetch = async () => {
  try {
    const response = await getAppealsBySearch(searchString.value);
    appeals.value = response.data.appeals;
  } catch {
    return null;
  }
};

watch(searchString, async () => debouncedSearch());

onMounted(() => fetch());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MainHeader, { class: "header" }),
      _createVNode(DashboardActions, {
        "show-filters": false,
        class: "dashboard-actions",
        modelValue: searchString.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchString).value = $event)),
        modelModifiers: { trim: true }
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(BaseWidgetTemplate, {
      theme: "white",
      class: "content"
    }, {
      default: _withCtx(() => [
        (!appeals.value.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Заявок не найдено"))
          : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appeals.value, (appeal) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: appeal.id
                }, [
                  _createVNode(AppealsListItem, { appeal: appeal }, null, 8, ["appeal"])
                ]))
              }), 128))
            ]))
      ]),
      _: 1
    })
  ]))
}
}

})